// AUTO-GENERATED by scripts/wp-post-dates.mjs — do not edit by hand.
// WordPress post dates, local time (UTC-5), from https://thriverestorehair.kinsta.cloud/wp-json/wp/v2/posts.
export type WpPostDates = { published: string; modified: string };

export const WP_POST_DATES: Record<string, WpPostDates> = {
  "10-ways-actually-make-hair-grow": {
    published: "2015-05-25T12:09:23",
    modified: "2026-02-18T11:50:32",
  },
  "5-causes-of-alopecia": {
    published: "2022-03-16T09:07:11",
    modified: "2026-02-19T14:19:51",
  },
  "7-reasons-why-you-should-book-your-hair-transplant-in-the-new-year": {
    published: "2021-12-30T07:19:19",
    modified: "2025-07-14T15:31:34",
  },
  "adam-a": {
    published: "2024-02-18T21:17:35",
    modified: "2024-06-06T16:58:02",
  },
  "age-hair-transplant": {
    published: "2017-03-16T04:16:44",
    modified: "2025-09-16T15:10:07",
  },
  "alopecia-difference": {
    published: "2017-06-01T23:56:43",
    modified: "2026-08-21T16:27:10",
  },
  "anthony-c": {
    published: "2024-02-18T21:11:05",
    modified: "2024-06-06T16:58:02",
  },
  "anti-aging-strategies-for-women": {
    published: "2016-02-11T12:31:52",
    modified: "2025-08-29T16:28:43",
  },
  "are-laser-therapy-helmets-for-real": {
    published: "2016-03-23T19:18:41",
    modified: "2026-02-20T13:32:41",
  },
  "are-there-discreet-hair-transplant-methods-that-dont-require-shaving": {
    published: "2026-01-30T11:59:05",
    modified: "2026-08-21T16:28:22",
  },
  "are-there-discreet-options-for-public-figures-seeking-hair-restoration": {
    published: "2026-01-30T12:43:48",
    modified: "2026-08-21T16:30:49",
  },
  "artas-work-curly-hair": {
    published: "2017-06-05T04:04:22",
    modified: "2026-08-24T15:37:49",
  },
  "artur-l": {
    published: "2024-11-04T00:47:49",
    modified: "2024-12-16T04:07:36",
  },
  "ask-about-hair-loss": {
    published: "2017-05-18T11:05:31",
    modified: "2025-07-15T10:00:11",
  },
  "bald-myths": {
    published: "2015-05-25T12:05:40",
    modified: "2025-08-27T14:47:22",
  },
  "balding-at-20": {
    published: "2019-06-27T18:51:48",
    modified: "2026-08-21T16:57:05",
  },
  "baldness-gene-come-mother-father": {
    published: "2017-02-16T16:44:36",
    modified: "2026-08-24T15:43:43",
  },
  "baldness-skip-generation": {
    published: "2018-01-07T21:15:52",
    modified: "2026-08-24T16:21:23",
  },
  "beard-transplant": {
    published: "2021-04-05T17:53:31",
    modified: "2025-07-14T15:36:59",
  },
  "beard-transplants": {
    published: "2026-02-09T10:42:45",
    modified: "2026-08-21T16:35:35",
  },
  "best-affordable-hair-transplant-clinic-with-proven-results": {
    published: "2025-12-10T14:32:39",
    modified: "2026-08-21T16:36:51",
  },
  "best-hair-transplant-results-near-me": {
    published: "2025-12-12T15:31:48",
    modified: "2026-08-21T16:48:50",
  },
  "best-reviewed-hair-transplant-clinics-for-results": {
    published: "2025-12-10T16:31:31",
    modified: "2026-08-21T16:54:01",
  },
  "bill-p": {
    published: "2024-06-18T20:27:19",
    modified: "2024-08-12T04:28:12",
  },
  "bora-g": {
    published: "2024-02-18T20:32:43",
    modified: "2024-06-06T16:58:23",
  },
  "braiding-can-make-your-hair-fall-out": {
    published: "2017-04-27T20:25:56",
    modified: "2025-08-27T14:45:08",
  },
  "brandon-h": {
    published: "2024-02-18T21:53:56",
    modified: "2024-08-04T16:45:50",
  },
  "brent-l": {
    published: "2024-02-18T19:21:39",
    modified: "2024-06-26T04:13:08",
  },
  "brian-s": {
    published: "2024-02-24T19:25:27",
    modified: "2024-08-04T16:46:36",
  },
  "brian-urlacher": {
    published: "2024-02-18T16:14:38",
    modified: "2025-05-27T12:30:27",
  },
  "brian-urlacher-restore": {
    published: "2016-05-20T08:29:23",
    modified: "2025-05-31T18:52:09",
  },
  "brian-urlacher-teaches-men-how-to-live-with-hair": {
    published: "2024-02-21T10:20:41",
    modified: "2026-02-18T12:38:23",
  },
  "brian-urlachers-tackling-balding-with-restore": {
    published: "2023-11-03T12:14:53",
    modified: "2026-08-21T16:33:58",
  },
  "bryan-b": {
    published: "2024-02-18T20:59:12",
    modified: "2024-07-09T11:43:36",
  },
  "bryan-bickell": {
    published: "2024-02-18T20:54:51",
    modified: "2024-06-06T16:58:23",
  },
  "causes-of-hair-loss": {
    published: "2022-05-17T14:50:50",
    modified: "2026-08-25T12:29:11",
  },
  "celebrities-with-hair-transplants": {
    published: "2026-01-08T16:40:18",
    modified: "2026-08-21T17:01:31",
  },
  "chicago-hair-restoration": {
    published: "2022-03-08T05:37:19",
    modified: "2026-08-24T14:55:21",
  },
  "chili-oil-promote-hair-growth": {
    published: "2016-01-25T12:32:35",
    modified: "2026-02-20T13:34:25",
  },
  "chris-e": {
    published: "2024-06-19T04:02:48",
    modified: "2024-08-04T16:59:19",
  },
  "chris-l": {
    published: "2024-03-26T04:49:54",
    modified: "2024-06-06T16:58:00",
  },
  "christopher-r": {
    published: "2024-06-18T21:05:41",
    modified: "2024-08-04T16:57:22",
  },
  "claus-r": {
    published: "2024-05-18T20:32:03",
    modified: "2024-08-04T16:52:51",
  },
  "clone-of-does-restore-use-robotics-in-hair-transplant-surgeries": {
    published: "2026-01-28T15:19:58",
    modified: "2026-08-21T16:31:55",
  },
  "clone-of-how-soon-will-transplanted-hair-start-to-grow": {
    published: "2026-01-30T11:16:05",
    modified: "2026-02-27T15:58:05",
  },
  "clone-of-why-do-some-men-need-multiple-hair-transplant-sessions": {
    published: "2026-01-28T14:54:49",
    modified: "2026-08-24T15:52:13",
  },
  "correcting-previous-hair-transplant-surgeries": {
    published: "2022-05-18T05:42:06",
    modified: "2026-08-24T14:57:04",
  },
  "cure-for-baldness": {
    published: "2019-01-24T16:48:27",
    modified: "2025-08-18T22:37:18",
  },
  "dandruff-and-hair-loss": {
    published: "2018-07-17T18:13:28",
    modified: "2026-08-21T16:56:05",
  },
  "danny-kanell": {
    published: "2024-05-18T19:37:35",
    modified: "2024-12-08T16:31:10",
  },
  "darrell-w": {
    published: "2024-04-01T01:51:40",
    modified: "2024-06-06T16:58:00",
  },
  "dave-s": {
    published: "2024-02-18T19:44:30",
    modified: "2024-08-04T16:49:38",
  },
  "dean-d": {
    published: "2024-05-18T21:36:19",
    modified: "2024-08-04T16:59:06",
  },
  "deion-sanders": {
    published: "2024-02-18T18:21:24",
    modified: "2024-06-26T00:21:54",
  },
  "deion-sanders-hair-transplant": {
    published: "2023-10-31T08:26:56",
    modified: "2026-08-24T14:58:07",
  },
  "dht-hair-loss": {
    published: "2019-05-21T20:39:15",
    modified: "2026-08-24T16:09:28",
  },
  "diet-hair-loss-connection": {
    published: "2016-02-16T12:33:41",
    modified: "2025-08-27T14:53:46",
  },
  "do-hair-plugs-look-natural": {
    published: "2026-01-09T13:59:03",
    modified: "2026-08-28T14:09:01",
  },
  "do-hair-transplants-work": {
    published: "2022-07-11T15:30:59",
    modified: "2026-08-24T15:36:53",
  },
  "do-you-know-the-effect-age-has-on-your-hairline": {
    published: "2021-04-26T14:49:00",
    modified: "2026-08-21T16:26:23",
  },
  "doc-im-23-balding": {
    published: "2016-11-29T17:42:10",
    modified: "2026-08-25T11:24:47",
  },
  "does-a-hair-transplant-hurt": {
    published: "2020-06-01T15:25:39",
    modified: "2026-08-24T15:42:20",
  },
  "donnie-b": {
    published: "2024-02-18T20:26:53",
    modified: "2024-09-20T00:27:24",
  },
  "dr-james-harris-denver": {
    published: "2021-05-20T17:08:38",
    modified: "2026-08-21T16:47:21",
  },
  "drew-j": {
    published: "2024-02-18T18:48:39",
    modified: "2024-06-24T05:58:40",
  },
  "early-signs-of-baldness": {
    published: "2019-08-19T16:44:08",
    modified: "2026-03-11T15:33:30",
  },
  "eddie-m": {
    published: "2024-02-22T01:11:38",
    modified: "2024-06-06T16:58:00",
  },
  "edwin-w": {
    published: "2024-02-18T21:38:13",
    modified: "2024-06-06T16:58:01",
  },
  "enrique-b": {
    published: "2024-03-10T20:59:49",
    modified: "2024-06-06T16:58:00",
  },
  "erik-g": {
    published: "2024-03-03T23:27:33",
    modified: "2025-08-20T00:29:56",
  },
  "evaluating-the-cost-of-a-hair-transplant": {
    published: "2024-02-21T12:14:32",
    modified: "2026-03-11T14:09:41",
  },
  "eyebrow-regrowth": {
    published: "2018-10-19T05:04:45",
    modified: "2026-03-11T14:12:02",
  },
  "eyebrow-transplant": {
    published: "2022-05-17T14:36:19",
    modified: "2026-08-24T16:32:24",
  },
  "famous-people-with-hair-transplants": {
    published: "2026-01-08T17:14:17",
    modified: "2026-08-24T16:12:05",
  },
  "female-hair-loss": {
    published: "2020-04-08T22:22:11",
    modified: "2025-05-31T18:52:09",
  },
  "follicle-by-follicle": {
    published: "2016-05-24T15:45:08",
    modified: "2025-10-20T16:52:59",
  },
  "fue-hair-transplant-care-when-to-wash-your-hair": {
    published: "2024-01-08T10:58:09",
    modified: "2026-08-24T16:13:54",
  },
  "fue-or-fut-hair-transplant": {
    published: "2020-06-17T13:49:06",
    modified: "2026-08-24T16:15:12",
  },
  "genes-human-hair-growth": {
    published: "2016-05-24T18:03:41",
    modified: "2025-08-27T15:23:07",
  },
  "genetics-and-hair-loss-who-do-you-inherit-it-from": {
    published: "2024-06-29T08:56:00",
    modified: "2026-08-24T16:17:17",
  },
  "gino-t": {
    published: "2024-05-18T20:34:17",
    modified: "2024-08-04T16:53:59",
  },
  "hair-by-the-numbers": {
    published: "2022-05-18T05:53:45",
    modified: "2025-08-27T15:21:38",
  },
  "hair-grafts": {
    published: "2018-09-11T15:51:19",
    modified: "2026-08-24T16:20:11",
  },
  "hair-loss-in-women": {
    published: "2015-10-20T12:09:47",
    modified: "2026-02-19T14:46:55",
  },
  "hair-loss-in-women-exploring-female-pattern-baldness": {
    published: "2023-12-19T13:22:47",
    modified: "2026-08-24T16:23:14",
  },
  "hair-loss-medications-what-you-need-to-know": {
    published: "2020-03-31T21:48:28",
    modified: "2026-03-06T13:12:21",
  },
  "hair-loss-myths": {
    published: "2017-05-17T15:00:46",
    modified: "2025-07-15T11:44:20",
  },
  "hair-loss-prevention-3-myths-5-facts": {
    published: "2017-12-21T04:16:47",
    modified: "2026-02-20T13:30:35",
  },
  "hair-restoration-in-the-greater-chicago-area": {
    published: "2016-05-23T12:38:24",
    modified: "2026-08-24T16:24:47",
  },
  "hair-restoration-research": {
    published: "2022-05-18T05:34:58",
    modified: "2026-08-24T15:55:50",
  },
  "hair-restoration-research-tips": {
    published: "2016-08-02T10:44:09",
    modified: "2025-05-31T19:18:50",
  },
  "hair-survival-program": {
    published: "2024-05-18T06:38:48",
    modified: "2025-08-18T22:13:05",
  },
  "hair-throughout-history": {
    published: "2017-01-16T18:43:41",
    modified: "2026-08-24T16:30:13",
  },
  "hair-transplant-an-effective-way-of-hair-restoration": {
    published: "2021-04-02T12:48:00",
    modified: "2025-10-10T14:05:37",
  },
  "hair-transplant-receded-temples": {
    published: "2016-11-08T04:49:54",
    modified: "2025-10-10T14:06:24",
  },
  "hair-transplant-recovery-for-men-women-what-to-expect": {
    published: "2020-05-01T05:53:18",
    modified: "2025-08-27T15:38:45",
  },
  "hair-transplant-scar-fue-whats-truth": {
    published: "2024-11-20T17:43:24",
    modified: "2026-08-24T16:35:32",
  },
  "hair-transplant-secret": {
    published: "2016-06-06T18:14:25",
    modified: "2026-03-06T13:32:49",
  },
  "hair-transplant-success-rate": {
    published: "2018-06-03T05:34:19",
    modified: "2026-03-06T14:32:37",
  },
  "hat-collection": {
    published: "2016-01-24T12:33:05",
    modified: "2026-08-24T16:18:44",
  },
  "helmets-cause-hair-loss": {
    published: "2016-06-16T11:10:45",
    modified: "2026-08-24T15:39:30",
  },
  "history-of-fue": {
    published: "2016-06-14T11:03:10",
    modified: "2026-08-25T12:25:45",
  },
  "how-choose-hair-transplant-doctor": {
    published: "2024-10-08T14:56:44",
    modified: "2026-08-25T11:18:14",
  },
  "how-discreet-is-a-restore-hair-no-shave-fue-hair-transplant-for-working-professionals": {
    published: "2026-02-04T15:56:40",
    modified: "2026-02-28T17:57:20",
  },
  "how-do-clinics-ensure-donor-area-preservation-for-future-needs": {
    published: "2026-01-29T12:56:06",
    modified: "2026-02-28T17:48:32",
  },
  "how-do-clinics-ensure-natural-hairline-design": {
    published: "2026-01-30T13:07:31",
    modified: "2026-08-24T16:42:31",
  },
  "how-do-i-choose-between-surgical-and-non-surgical-hair-restoration": {
    published: "2026-01-28T15:43:35",
    modified: "2026-08-24T16:38:22",
  },
  "how-does-body-hair-transplantation-work-and-when-is-it-used": {
    published: "2026-02-10T12:58:31",
    modified: "2026-08-28T14:42:40",
  },
  "how-important-is-physician-involvement-versus-technicians-during-fue": {
    published: "2026-01-30T13:24:36",
    modified: "2026-08-24T16:51:05",
  },
  "how-long-do-hair-transplant-results-last": {
    published: "2026-01-29T14:52:43",
    modified: "2026-07-01T02:36:28",
  },
  "how-many-grafts": {
    published: "2021-12-10T07:31:48",
    modified: "2026-08-24T16:55:52",
  },
  "how-many-grafts-do-i-need-to-restore-a-receding-hairline": {
    published: "2026-01-29T15:19:09",
    modified: "2026-08-24T16:53:56",
  },
  "how-quickly-does-a-hair-transplant-start-to-grow": {
    published: "2022-02-07T06:14:26",
    modified: "2026-08-24T16:52:14",
  },
  "how-soon-can-i-return-to-work-after-a-hair-transplant": {
    published: "2020-07-06T14:31:38",
    modified: "2026-03-11T13:55:39",
  },
  "how-soon-will-transplanted-hair-start-to-grow": {
    published: "2026-01-29T16:25:54",
    modified: "2026-02-28T17:51:15",
  },
  "how-to-maintain-privacy-and-discretion-throughout-the-hair-restoration-process": {
    published: "2026-02-04T16:19:08",
    modified: "2026-08-25T11:18:59",
  },
  "how-to-plan-a-staged-approach-for-progressive-hair-loss": {
    published: "2026-01-28T16:01:48",
    modified: "2026-08-25T11:21:53",
  },
  "how-to-prevent-hair-loss-in-men-women": {
    published: "2019-09-11T17:05:58",
    modified: "2025-08-18T22:50:05",
  },
  "how-to-treat-hair-loss-and-your-options": {
    published: "2019-07-09T22:19:53",
    modified: "2026-08-25T11:23:44",
  },
  "ian-happ": {
    published: "2024-02-18T18:56:00",
    modified: "2024-07-23T06:58:32",
  },
  "ian-m": {
    published: "2024-02-18T20:25:36",
    modified: "2024-06-26T02:48:09",
  },
  "is-it-too-late-for-a-hair-transplant": {
    published: "2020-07-09T20:41:35",
    modified: "2025-08-18T22:26:11",
  },
  "is-there-really-a-cure-for-baldness": {
    published: "2024-01-17T10:19:43",
    modified: "2026-08-25T11:30:45",
  },
  "its-not-the-hair-its-the-loss": {
    published: "2016-03-23T19:18:20",
    modified: "2025-05-31T19:19:00",
  },
  "jake-k": {
    published: "2024-07-18T21:13:45",
    modified: "2024-08-04T16:57:42",
  },
  "jake-w": {
    published: "2024-02-18T20:25:04",
    modified: "2024-06-26T04:08:41",
  },
  "james-d": {
    published: "2024-05-18T20:33:15",
    modified: "2024-08-04T16:53:49",
  },
  "james-l": {
    published: "2024-05-18T20:57:22",
    modified: "2024-08-04T16:56:54",
  },
  "james-w": {
    published: "2024-02-18T19:48:38",
    modified: "2024-06-26T04:09:33",
  },
  "jamie-s": {
    published: "2024-02-18T21:27:53",
    modified: "2024-08-04T16:52:33",
  },
  "jason-c": {
    published: "2024-02-18T21:15:02",
    modified: "2024-06-06T16:58:02",
  },
  "jeremy-a": {
    published: "2024-05-10T03:57:57",
    modified: "2024-07-28T23:11:00",
  },
  "jim-cornelison": {
    published: "2024-02-18T20:30:12",
    modified: "2024-10-27T22:25:49",
  },
  "joe-t": {
    published: "2024-03-03T23:32:29",
    modified: "2024-11-04T00:41:39",
  },
  "john-a": {
    published: "2024-05-10T04:41:11",
    modified: "2024-07-28T23:11:33",
  },
  "john-k": {
    published: "2024-03-10T21:10:03",
    modified: "2024-06-06T16:58:00",
  },
  "jonathan-s": {
    published: "2024-03-03T23:28:06",
    modified: "2024-06-06T16:58:00",
  },
  "jordan-s": {
    published: "2024-03-10T21:18:09",
    modified: "2024-06-06T16:58:00",
  },
  "joseph-b": {
    published: "2024-03-10T21:08:22",
    modified: "2024-06-06T16:58:00",
  },
  "joseph-s": {
    published: "2024-08-16T00:34:52",
    modified: "2024-08-16T00:38:15",
  },
  "josh-k": {
    published: "2024-02-18T18:50:11",
    modified: "2024-06-26T01:04:32",
  },
  "juanito-q": {
    published: "2024-02-19T02:32:13",
    modified: "2024-06-06T16:58:01",
  },
  "kevin-b": {
    published: "2024-02-18T19:46:59",
    modified: "2025-05-13T00:22:55",
  },
  "kevin-streelman": {
    published: "2024-02-18T18:57:21",
    modified: "2025-08-18T05:09:22",
  },
  "kevin-vandam": {
    published: "2024-02-18T20:31:00",
    modified: "2025-07-18T12:37:16",
  },
  "l%d0%b0%d1%95%d0%b5rcap-tr%d0%b5%d0%b0tm%d0%b5nt": {
    published: "2015-10-19T12:09:35",
    modified: "2026-02-20T13:14:50",
  },
  "lance-w": {
    published: "2024-02-26T00:56:40",
    modified: "2024-08-04T17:00:19",
  },
  "larry-y": {
    published: "2024-05-24T02:58:21",
    modified: "2024-07-28T23:12:07",
  },
  "laser-cap-for-hair-loss": {
    published: "2016-10-24T12:18:25",
    modified: "2026-08-25T11:27:03",
  },
  "laser-hair-combs-hair-loss-really": {
    published: "2016-12-16T22:07:55",
    modified: "2026-08-25T11:27:58",
  },
  "life-after-a-hair-transplant": {
    published: "2020-10-23T04:47:06",
    modified: "2025-08-29T16:09:44",
  },
  "life-changing-hair-transplant": {
    published: "2016-06-04T15:09:35",
    modified: "2025-07-15T11:46:02",
  },
  "logan-s": {
    published: "2024-02-27T00:21:14",
    modified: "2024-06-06T16:58:00",
  },
  "low-level-laser-therapy-for-hair-loss": {
    published: "2022-05-17T14:33:36",
    modified: "2026-03-11T13:34:42",
  },
  "ludwig-scale": {
    published: "2019-06-04T20:41:51",
    modified: "2026-08-25T11:56:06",
  },
  "male-hair-loss-hurts": {
    published: "2016-02-16T12:29:58",
    modified: "2025-05-31T19:19:00",
  },
  "male-pattern-baldness-treatment": {
    published: "2024-06-17T14:42:12",
    modified: "2026-08-21T16:50:48",
  },
  "martin-b": {
    published: "2024-05-18T21:21:51",
    modified: "2024-08-04T16:58:04",
  },
  "matt-forte": {
    published: "2024-02-18T19:33:00",
    modified: "2024-07-23T06:57:07",
  },
  "michael-s": {
    published: "2024-02-18T21:23:14",
    modified: "2024-06-06T16:58:02",
  },
  "mike-bibby": {
    published: "2024-02-18T19:35:25",
    modified: "2024-11-03T21:18:18",
  },
  "minimal-scarring-results": {
    published: "2025-12-15T11:17:50",
    modified: "2026-08-21T16:38:59",
  },
  "mitch-c": {
    published: "2024-02-18T21:25:59",
    modified: "2024-06-06T16:58:02",
  },
  "myths-about-the-causes-of-baldness": {
    published: "2022-05-17T14:45:34",
    modified: "2026-02-19T14:45:05",
  },
  "natural-therapies-for-hair-restorations": {
    published: "2021-04-05T12:53:00",
    modified: "2026-02-19T14:55:23",
  },
  "nick-g": {
    published: "2024-02-18T19:45:28",
    modified: "2024-06-26T02:51:48",
  },
  "noah-o": {
    published: "2024-02-18T20:53:03",
    modified: "2025-04-28T04:13:12",
  },
  "non-surgical-hair-loss-treatment-cost": {
    published: "2018-04-27T19:41:01",
    modified: "2026-08-25T11:29:05",
  },
  "non-surgical-hair-loss-treatments-at-restore-hair": {
    published: "2023-12-07T17:27:39",
    modified: "2026-08-25T12:24:28",
  },
  "normal-men-hair-transplant": {
    published: "2017-08-18T19:21:01",
    modified: "2025-08-16T23:01:19",
  },
  "pat-hoberg": {
    published: "2024-02-18T19:32:25",
    modified: "2024-08-04T16:50:16",
  },
  "prevent-hair-loss": {
    published: "2021-03-31T12:37:00",
    modified: "2026-02-20T13:10:34",
  },
  "prp-treatment-for-hair-restoration-its-effectiveness-and-all-things-to-know-about-prp-therapy": {
    published: "2021-04-07T12:57:00",
    modified: "2025-10-10T14:05:03",
  },
  "psychology-of-hair-loss": {
    published: "2022-05-17T14:52:20",
    modified: "2026-02-20T13:14:13",
  },
  "psychology-of-hair-loss-2": {
    published: "2016-05-28T12:45:42",
    modified: "2026-02-20T13:35:21",
  },
  "ray-v": {
    published: "2024-02-18T21:24:39",
    modified: "2024-06-06T16:58:02",
  },
  "receding-hairline-treatment": {
    published: "2022-05-17T14:38:01",
    modified: "2026-08-25T11:34:21",
  },
  "recognizing-the-first-signs-of-hair-thinning": {
    published: "2023-11-22T12:08:52",
    modified: "2026-08-25T11:35:22",
  },
  "richard-s": {
    published: "2024-02-18T21:16:19",
    modified: "2024-06-06T16:58:02",
  },
  "rick-m": {
    published: "2024-02-18T18:41:13",
    modified: "2024-07-28T23:08:32",
  },
  "robby-h": {
    published: "2024-02-18T21:20:19",
    modified: "2024-06-06T16:58:02",
  },
  "robert-burns": {
    published: "2024-02-18T20:55:00",
    modified: "2024-07-23T06:17:02",
  },
  "robert-l": {
    published: "2024-02-28T19:27:26",
    modified: "2024-08-04T16:46:45",
  },
  "rogaine-side-effects": {
    published: "2018-11-27T22:01:33",
    modified: "2026-08-25T11:36:08",
  },
  "ryan-d": {
    published: "2024-02-18T18:55:24",
    modified: "2025-02-25T00:57:25",
  },
  "ryan-e": {
    published: "2024-03-10T21:15:07",
    modified: "2024-06-06T16:58:00",
  },
  "steve-c": {
    published: "2024-06-07T01:53:55",
    modified: "2024-06-17T02:08:47",
  },
  "steve-p": {
    published: "2024-03-10T20:29:46",
    modified: "2024-06-06T16:58:00",
  },
  "stop-hair-shedding": {
    published: "2018-03-20T16:46:43",
    modified: "2026-08-21T16:58:46",
  },
  "stress-hair-loss-really-connection": {
    published: "2016-10-28T04:17:30",
    modified: "2025-05-31T19:18:56",
  },
  "surprising-hair-facts": {
    published: "2016-08-16T23:42:55",
    modified: "2026-08-25T11:37:02",
  },
  "thank-you-mom": {
    published: "2015-05-25T12:06:16",
    modified: "2025-07-15T11:49:03",
  },
  "the-impact-of-hair-loss-balding": {
    published: "2024-10-09T14:41:31",
    modified: "2026-02-20T13:33:44",
  },
  "the-true-hair-restoration-cost": {
    published: "2022-02-07T05:32:53",
    modified: "2026-08-25T11:41:55",
  },
  "tim-b": {
    published: "2024-06-19T04:01:57",
    modified: "2024-08-12T04:31:20",
  },
  "tim-c": {
    published: "2024-03-10T20:21:41",
    modified: "2024-06-06T16:58:00",
  },
  "todd-d": {
    published: "2024-02-18T19:29:44",
    modified: "2024-07-28T23:09:08",
  },
  "tom-c": {
    published: "2024-06-18T21:00:28",
    modified: "2024-08-04T16:57:11",
  },
  "tommy-b": {
    published: "2024-07-10T21:12:17",
    modified: "2024-08-04T16:59:52",
  },
  "tony-l": {
    published: "2024-02-18T19:20:30",
    modified: "2024-07-23T06:54:34",
  },
  "top-hair-restoration-providers-at-best-hair-transplant-clinic": {
    published: "2025-12-10T13:41:22",
    modified: "2026-08-25T12:18:40",
  },
  "top-hair-restoration-providers-best-hair-transplant-clinic": {
    published: "2025-12-09T00:24:40",
    modified: "2026-08-25T12:13:06",
  },
  "transgender-hair-transplant": {
    published: "2021-04-22T20:47:39",
    modified: "2026-08-25T11:43:07",
  },
  "treatment-of-stress-related-hair-loss": {
    published: "2021-04-09T13:00:00",
    modified: "2026-03-11T14:06:58",
  },
  "types-of-hair-loss-treatment": {
    published: "2022-05-17T14:32:14",
    modified: "2025-09-04T13:04:47",
  },
  "understand-the-common-elements-that-cause-hair-loss": {
    published: "2021-05-04T13:03:00",
    modified: "2025-08-27T16:27:32",
  },
  "undetectable-hair-transplant": {
    published: "2016-01-23T12:34:08",
    modified: "2025-07-14T14:18:53",
  },
  "varun-k": {
    published: "2024-06-07T01:44:12",
    modified: "2024-07-28T23:12:35",
  },
  "what-are-common-myths-about-hair-transplants-debunked-by-experts": {
    published: "2026-02-04T14:09:14",
    modified: "2026-08-25T11:45:05",
  },
  "what-are-the-latest-innovations-in-hair-transplant-technology": {
    published: "2026-01-29T12:24:00",
    modified: "2026-08-25T11:47:08",
  },
  "what-factors-determine-candidacy-for-a-hair-transplant": {
    published: "2026-02-04T15:19:19",
    modified: "2026-08-25T11:51:34",
  },
  "what-is-dr-james-harriss-role-at-restore": {
    published: "2026-02-10T12:12:12",
    modified: "2026-08-25T11:52:41",
  },
  "what-is-the-norwood-scale": {
    published: "2016-08-16T23:50:50",
    modified: "2026-08-25T11:58:24",
  },
  "what-makes-a-hair-transplant-look-undetectable": {
    published: "2026-02-04T14:47:51",
    modified: "2026-08-25T11:59:43",
  },
  "what-percentage-of-hair-transplants-are-successful": {
    published: "2021-06-17T13:32:51",
    modified: "2026-02-20T13:07:04",
  },
  "what-should-i-ask-my-hair-transplant-surgeon-to-ensure-a-natural-result": {
    published: "2026-01-09T13:14:32",
    modified: "2026-08-25T12:02:01",
  },
  "what-should-i-consider-before-choosing-a-hair-transplant-clinic": {
    published: "2026-01-09T11:19:22",
    modified: "2026-08-25T12:03:19",
  },
  "what-type-of-hair-transplant-procedure-best": {
    published: "2024-11-15T17:08:13",
    modified: "2026-08-21T16:52:18",
  },
  "whats-the-best-affordable-fue-hair-transplant-provider": {
    published: "2025-12-16T11:47:21",
    modified: "2026-08-25T12:07:34",
  },
  "whats-the-best-doctor-for-fue-hair-transplants-in-nyc": {
    published: "2025-12-16T10:23:59",
    modified: "2026-08-25T12:09:05",
  },
  "whats-the-best-fue-only-hair-restoration-clinic": {
    published: "2025-12-15T15:26:24",
    modified: "2026-08-25T12:11:16",
  },
  "whats-the-best-hair-transplant-clinic-for-natural-looking-results": {
    published: "2025-12-15T12:57:17",
    modified: "2026-08-28T14:48:29",
  },
  "whats-the-best-hair-transplant-surgeon-for-dense-coverage": {
    published: "2025-12-11T10:50:32",
    modified: "2026-08-25T12:17:26",
  },
  "which-company-has-the-best-before-and-after-hair-transplant-photos": {
    published: "2025-12-12T16:02:14",
    modified: "2026-08-25T12:20:04",
  },
  "which-hair-restoration-clinic-gives-the-best-fue-results": {
    published: "2025-12-12T16:34:24",
    modified: "2026-08-25T12:23:22",
  },
  "who-is-a-good-candidate-for-hair-transplantation": {
    published: "2021-06-17T13:27:30",
    modified: "2026-03-11T14:03:56",
  },
  "why-do-some-men-need-multiple-hair-transplant-sessions": {
    published: "2026-01-28T13:47:47",
    modified: "2026-08-25T12:27:24",
  },
  "why-women-lose-hair": {
    published: "2016-06-20T19:55:59",
    modified: "2026-08-25T11:31:58",
  },
  "will-i-go-bald": {
    published: "2019-05-06T20:25:37",
    modified: "2025-08-18T22:36:24",
  },
  "will-r": {
    published: "2024-02-18T20:31:30",
    modified: "2024-09-20T00:22:43",
  },
  "willie-c": {
    published: "2024-02-18T20:40:36",
    modified: "2024-06-06T16:58:23",
  },
  "worrying-about-hair-loss": {
    published: "2017-05-26T11:55:37",
    modified: "2025-07-15T10:00:52",
  },
  "zach-johnson": {
    published: "2024-02-18T18:28:16",
    modified: "2024-06-26T01:06:36",
  },
};
